
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton } from '@/components';
import { useStarterPackRewardList } from '@/modules/starter/pack/reward/model/list';
import { StarterPackRewardOptions } from '@/modules/starter/pack/reward/types';
import { ROUTE_NAME_STARTER } from '@/modules/starter/pack/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_STARTER.PACK.REWARD.INDEX,
    components: { AppTable, AppButton, AppCard },
    setup() {
        const { list, total, fetchList, starterPackId, canUpdateReward, actions } = useStarterPackRewardList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: StarterPackRewardOptions },
                { type: TableColumnType.RouterLink, label: 'Item', key: 'itemName', to: row => row.itemLink },
                { type: TableColumnType.Text, label: 'Quantity', key: 'quantity' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !canUpdateReward.value,
                        onClick: () => actions.remove(row.type, row.data)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, starterPackId, canUpdateReward, ROUTE_NAME_STARTER };
    }
});
